import { useMemo } from 'react';
import { useFrame } from '@react-three/fiber';
import * as THREE from 'three';
import {
  EyeBlinkKey,
  IdProps,
  Lerp_Speed,
} from '~/components/ChatAvatar/Canvas/Character/RobotCharacter';
import useChatAvatarStore from '~/store/useChatAvatarStore';

const useExpression = ({ id }: IdProps) => {
  const morphs = useChatAvatarStore((state) => state.character?.[id]?.morphs);
  const morphKeys = useChatAvatarStore(
    (state) => state.character?.[id]?.morphKeys,
  );
  const avatarQueue = useChatAvatarStore(
    (state) => state.character?.[id]?.avatarQueue,
  );
  const queueMorphIndex = useChatAvatarStore(
    (state) => state.character?.[id]?.queueMorphIndex,
  );
  const keys = useMemo(() => {
    if (morphKeys) return [...morphKeys];
    return [];
  }, [morphKeys]);

  const handleLerpTarget = (target: string, value: number) => {
    morphs?.forEach((morph) => {
      const index = morph.morphTargetDictionary[target];
      if (index) {
        morph.morphTargetInfluences[index] = THREE.MathUtils.lerp(
          morph.morphTargetInfluences[index],
          value,
          Lerp_Speed,
        );
      }
    });
  };

  useFrame(() => {
    const map = avatarQueue?.value;
    keys?.forEach((key) => {
      if (EyeBlinkKey.includes(key)) {
        return;
      }

      if (map && map[key] && map[key][queueMorphIndex] >= 0) {
        handleLerpTarget(key, map[key][queueMorphIndex]);
      } else {
        handleLerpTarget(key, 0);
      }
    });
  });
};

export default useExpression;
